import { gql } from '@apollo/client';

export const GET_CURRENT_PRICES = gql`
    query GetCurrentPrices($productSku: String!, $storeId: String!) {
        getCurrentPrices(productSku: $productSku, storeId: $storeId) {
            cashbuildPrice
            pnlPrice
        }
    }
`;
